<template>
<div class="modal fade" tabindex="-1" role="dialog" id="modalBaixaEstoque">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title text-left">Finalizar Atendimento e Baixa no Estoque</h4>
      </div>
      <div class="modal-body">
        <table class="table table-striped table-bordered">
            <thead>
                <tr>
                    <td>Produto</td> 
                    <td>*Quantidade Utilizada</td> 
                    <td>Quantidade Em Estoque</td> 
                </tr>
            </thead>
            <tbody>
                <tr v-for="(produto, index) of produtos">
                    <td class="text-left"> {{ produto.Nome  }} </td> 
                    <td>
                      <input type="number" class="form-control" id="produto" min="0" placeholder="" v-model="produto.QuantidadeUtilizada">
                    </td> 
                    <td>{{ (produto.QuantidadeEmEstoque - produto.QuantidadeUtilizada) + '/' + produto.QuantidadeEmEstoque}}</td> 
                </tr>
            </tbody>
            <tfoot>
                <tr>
                  <td style="background:#2d618e; min-height:10px; max-height:10px; font-size:5px;" colspan="5"> &nbsp; </td>
                </tr>
            </tfoot>
        </table>  
        <div class="form-group text-left">
          <label for="atendentes">Atendentes</label>
          <v-select multiple v-model="atendentes" value="Id" label="Nome" :options="listaAtendentes"></v-select>
        </div>
        <div class="form-group text-left">
          <label for="observacoes">Observações</label>
          <textarea class="form-control" rows="1" id="observacoes" placeholder="Digite aqui as observações" v-model="observacoes" maxlength="100"></textarea>
          <small style="font-style:italic">Caracteres restantes: {{100 - observacoes.length}}</small>
        </div>
      </div>
      <div class="modal-footer">
        <div class="form-group text-right">
          <label for="fichaaprovacao">Deseja dar baixa na Ficha de Aprovação?</label>
          <input type="checkbox" v-model="baixaFicha" value="true"  />
        </div>
        <button type="button" class="btn btn-default" data-dismiss="modal">Fechar</button>
        <button type="button" class="btn btn-primary" @click="salvar" :disabled="disabledSave">
          <i class="fa fa-save" aria-hidden="true" v-show="!loadSave"></i> 
          <i class="fa fa-circle-o-notch fa-spin"  v-show="loadSave"></i>  
          Salvar  
        </button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div> 
</template>
<script>
import vSelect from 'vue-select'
export default {
  components: {
    vSelect
  },
  created: function () {
    this.listarProdutos()
    this.listarAtendentes()
  },
  computed: {
  },
  methods: {
    listarProdutos () {
      this.$http.get('estoque/listar?unidade=' + parseInt(localStorage.getItem('Unidade')))
        .then(function (res) {
          this.produtos = res.body
        })
    },
    listarAtendentes () {
      this.$http.get('configuracao/atendentes')
        .then(function (res) {
          this.listaAtendentes = res.body
        })
    },
    salvar () {
      this.disabledSave = true
      this.loadSave = true
      let baixa = {
        consideracoesFinais: this.observacoes,
        produtos: this.produtos,
        atendentes: this.atendentes,
        atendidos: this.selecionados,
        BaixaFichaAprovacao: this.baixaFicha,
        IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      }
      this.$http.put('estoque/baixa', baixa)
        .then(function (res) {
          alert('Atendimento finalizado com sucesso')
          location.reload()
        })
        .catch(function (err) {
          console.log(err)
          alert('Ops! - Algo de errado aconteceu.\nSe o problema persistir entre em contato com a área de Projetos.')
          this.disabledSave = false
          this.loadSave = false
        })
    }
  },
  props: ['selecionados'],
  data () {
    return {
      produtos: [],
      atendentes: '',
      observacoes: '',
      baixaFicha: false,
      listaAtendentes: [],
      loadSave: false,
      disabledSave: false
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// Finalizar.vue?24fb7ebe